import { type SVGProps } from 'react';

import { withDynamicStroke } from '../../withDynamicStroke';
const Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M10 18h4m2.18 4H7.82c-2.31 0-4.18-1.786-4.18-3.99v-4.877a2.6 2.6 0 0 0-.82-1.888c-1.216-1.16-1.058-3.083.333-4.048L9.54 2.763a4.34 4.34 0 0 1 4.918 0l6.389 4.434c1.39.965 1.548 2.888.332 4.048a2.6 2.6 0 0 0-.82 1.888v4.878c0 2.203-1.87 3.989-4.18 3.989Z"
    />
  </svg>
);
export const IconHome = withDynamicStroke(Icon);
